import { itwApi } from '../middlewares/api';
const getWhitlistBlacklistVehicles = (search) => {
    return itwApi.get('VehicleDetail/get-vehicle-detail', {
        params: search
    });
};
const getVehicleDetail = async (vehicleDetailId) => {
    var response = await itwApi.get(`VehicleDetail?VehicleDetailId=${vehicleDetailId}`);
    return response.data;
};
const updateVehicleDetail = async (vehicleId, vehicleData) => {
    const response = await itwApi.put(`/VehicleDetail/${vehicleId}`, vehicleData, {
        headers: {
            'accept': 'application/json',
        },
    });
    return response.data;
};
const deleteVehicleDetail = async (vehicleDetailId) => {
    var response = await itwApi.delete(`VehicleDetail/${vehicleDetailId}`);
    return response.data;
};
export const whitelistBlacklistApi = {
    getWhitlistBlacklistVehicles,
    getVehicleDetail,
    updateVehicleDetail,
    deleteVehicleDetail
};
